/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Summary_Knowledge_Past_2Inputs */



/**
* | output |
* | --- |
* | "looked through your files" |
*
* @param {Chat_Summary_Knowledge_Past_2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_summary_knowledge_past_2 = /** @type {((inputs?: Chat_Summary_Knowledge_Past_2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Summary_Knowledge_Past_2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("deine Dateien durchgesehen")
	return /** @type {LocalizedString} */ ("looked through your files")
});